import { LoginService } from 'app/services/login.service';
import { Injectable } from '@angular/core';
import { ConnectionService } from './connection.service';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs/Observable';
import { CommunicationLog } from '../entities/CommunicationLog';
import {Headers, Http, RequestOptions} from '@angular/http';
import {RequestInterceptor} from "./Interceptors/RequestInterceptor";

@Injectable()
export class CommunicationLogService {

  private readonly apiUrl: string;


  private getHeaders(company = null): RequestOptions {
    const headers: Headers = this.connectionService.GetAuthorizationHeader(company);
    return new RequestOptions({ headers });
  }

  constructor(private http: Http,
              private connectionService: ConnectionService,
              private config: AppConfig,
              private loginService: LoginService,
              private requestInterceptor: RequestInterceptor) {
    this.apiUrl = config.getConfig('endPointApiUrl');
  }

  public GetCommunicationLogs(taskNo: string, company: string = null): Observable<CommunicationLog[]> {
    let url = this.apiUrl + 'api/CommunicationLog/GetCommunicationLogs/';

    return this.requestInterceptor
      .get(url + taskNo, this.getHeaders(company))
      .map(resp => resp.json() as CommunicationLog[]);
  }

  public CreateCommunicationLog(communicationLog: CommunicationLog, company: string = null): Observable<any> {
    let url = this.apiUrl + 'api/CommunicationLog/Create';
    let params = JSON.stringify(communicationLog);

    return this.http
      .post(url, params, this.getHeaders(company))
      .map(resp => resp.json() as CommunicationLog[]);
  }

  public GenerateCommunicationLogObject(){
    let communicationLog: CommunicationLog = {
      Task_GUID: '',
      Creation_Date: new Date(),
      Note: '',
      Created_By_Ref: this.loginService.getLoggedInUserID(),
    };
    return communicationLog;
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/communication-log.service.ts